export enum VideoPlayerActionsEnum {
	TOGGLE_PLAYING_STATE = 'TOGGLE_PLAYING_STATE',
	SET_VOLUME = 'SET_VOLUME',
	SET_DURATION = 'SET_DURATION',
	SET_MINIMIZED = 'SET_MINIMIZED',
	SET_PLAYBACK_RATE = 'SET_PLAYBACK_RATE',
	SET_IS_DRAGGABLE = 'SET_IS_DRAGGABLE',
	SET_IS_COLLAPSED = 'SET_IS_COLLAPSED',
	SET_PLAYED_SECONDS = 'SET_PLAYED_SECONDS',
	SET_PLAYING_STATE = 'SET_PLAYING_STATE',
	SET_SEEKING = 'SET_SEEKING',
	SET_MULTIPLE = 'SET_MULTIPLE'
}
